export default "skymp5-front/ef8f1fb8b64039c003fe81c84ed91287.png";